import { FormFieldBase } from './form-field-base';

export class FormFieldCheckbox extends FormFieldBase<string> {
  override controlType = 'checkbox';
}
